import { Box } from '@lingoda/ui';
import type { AppointmentStatus } from '@lingoda/monolith-graphql';
import { ClassTileActions } from './ClassTileActions';
import { ClassTileStatus } from './ClassTileStatus';
import type { CommonProps } from '../../types/props';

interface Props extends Pick<CommonProps, 'onBook' | 'onDetails' | 'isPreview'> {
    status: AppointmentStatus;
    isUpcoming?: boolean;
    isBooked?: boolean;
    isPast: boolean;
    isLessonAttended: boolean | undefined;
    isLessonLocked: boolean;
    disableActions?: boolean;
    showStatus?: boolean;
}

export const ClassTileFooter = ({
    isPast,
    isBooked,
    onBook,
    onDetails,
    status,
    isUpcoming = false,
    isLessonAttended = false,
    isLessonLocked,
    disableActions,
    showStatus = true,
}: Props) => (
    <Box sx={{ mt: 3, minHeight: '20px' }}>
        {showStatus &&
            (isBooked || isPast ? (
                <ClassTileStatus isPast={isPast} status={status} isUpcoming={isUpcoming} />
            ) : (
                <ClassTileActions
                    isLessonAttended={isLessonAttended}
                    isLessonLocked={isLessonLocked}
                    onBook={onBook}
                    onDetails={onDetails}
                    disabled={disableActions}
                />
            ))}
    </Box>
);
